<template>
  <div v-if="formatted.date !== '-'">
    <div>{{ formatted.date }}</div>
    <div v-if="formatted.time">{{ formatted.time }}</div>
  </div>
  <span v-else>-</span>
</template>

<script>
import { splitRequestTableDate } from "@/utils/requestTableDates";

export default {
  name: "RequestTableDateCell",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    formatted() {
      return splitRequestTableDate(this.value);
    },
  },
};
</script>
